import * as React from "react"

import Layout from "../components/layout/layout.component"
import Seo from "../components/seo"

import NotFoundSVG from "../assets/img/404.svg"

const NotFoundPage = () => (
  <Layout>
    <Seo title="404: Not found" />
    <div className="min-h-screen flex flex-col items-center justify-center light-bulb-bg container">
      <img src={NotFoundSVG} alt="Not found" className="mb-6" />
      <h1 className="text-secondary text-lg font-bold">ΣΦΑΛΜΑ 404</h1>
      <p className="font-bold">Η σελίδα δεν βρέθηκε!</p>
    </div>
  </Layout>
)

export default NotFoundPage
